Date.prototype.normalizeHours = function (): Date {
	const date = new Date(this);
	date.setHours(12, 0, 0, 0);
	return date;
};

Date.prototype.getISODateStringWithoutTime = function (): string {
	const date = this.normalizeHours();
	return date.toISOString().split('T')[0];
};
